package fr.frux.core.common.config

import kotlinx.browser.window

/**
 * Sur le web, la webApp est déjà l'origine courante : pas de canal à poser côté hôte, contrairement
 * à [apiBaseUrl] qui vise un autre service.
 */
actual fun webAppBaseUrl(): String = window.location.origin
